//Handle Mobile Navigation
function handleMobileNavigation() {
    const mobileNav = document.getElementById("mobile-nav");
    if(mobileNav){
    const openMobileNav = () => {
        mobileNav.dataset.open = "true";
        document.body.style.overflowY = "hidden";
    };
    const closeMobileNav = () => {
        mobileNav.dataset.open = "false";
        document.body.style.overflowY = "scroll";
    };
    const toggleMobileNav = () => {
        if (mobileNav.dataset.open === "true") closeMobileNav();
        else openMobileNav();
    };
    mobileNav.addEventListener("click", toggleMobileNav);

    document.addEventListener("click", (e) => {
        if (
            mobileNav.dataset.open === "true" &&
            document.querySelector("main").contains(e.target)
        ) {
            closeMobileNav();
        }
    });
}
}
//Handle Dropdowns
function handleDropdown() {
    const dropdowns = document.querySelectorAll(".dropdown");
    const dropdownLists = document.querySelectorAll(".dropdown-list");
    const closeDropdowns = () => {
        dropdowns.forEach((dropdown) => {
            dropdown.dataset.open = "false";
        });
    };
    dropdowns.forEach((dropdown) => {
        dropdown.addEventListener("click", () => {
            if (dropdown.dataset.open === "true") dropdown.dataset.open = "false";
            else dropdown.dataset.open = "true";
        });
        document.addEventListener("click", (e) => {
            if (dropdown.dataset.open === "true" && !dropdown.contains(e.target)) {
                dropdown.dataset.open = "false";
            }
        });
    });

    dropdownLists.forEach((list) => {
        list.addEventListener("mouseleave", () => {
            if (window.innerWidth >= 1024) list.parentElement.dataset.open = "false";
        });
    });

    /*document.addEventListener("scroll", () => {
    closeDropdowns();
    });*/
}

//Handle Home Animation
function handleHomeAnimation() {
    const scrollers = document.querySelectorAll(".scroller");
    if (scrollers) {
    const infiniteScrollAnimation = () => {
        scrollers.forEach((scroller) => {
        const scrollerInner = scroller.querySelector(".scroller-inner");
        const scrollerContent = Array.from(scrollerInner.children);
        scrollerContent.forEach((el) => {
            const duplicatedItem = el.cloneNode(true);
            scrollerInner.appendChild(duplicatedItem);
        });
        });
    };
    infiniteScrollAnimation();
    }
}

//Handle Scroll To Top
function handleScrollToTop() {
    //Scroll to top
    const scrollToTop = document.getElementById("scroll-to-top");
    const pageProgress = document.getElementById("page-progress");
    if(scrollToTop){
    scrollToTop.addEventListener("click", () => {
    window.scrollTo(0, 0);
    });

    window.addEventListener("scroll", () => {
    const scrollPercentage =
        window.scrollY / (document.body.clientHeight - window.innerHeight);
    pageProgress.style.strokeDashoffset = `${(1 - scrollPercentage) * 305}`;
    if (window.scrollY >= window.innerHeight / 2) {
        scrollToTop.setAttribute("data-visible", "true");
    } else {
        scrollToTop.setAttribute("data-visible", "false");
    }
    document.activeElement.blur();
    });
}
}

//Handle Coupon Codes
function handleCouponCodes() {
    //Coupon code
    const couponCodeBtns = document.querySelectorAll(".coupon-code-btn");
    if (couponCodeBtns) {
    couponCodeBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
        navigator.clipboard
            .writeText(btn.previousElementSibling.value)
            .then(() => {
            btn.previousElementSibling.select();
            btn.dataset.copied = "true";
            btn.style.pointerEvents = "none";
            btn.previousElementSibling.value = 'Copied!';
            setTimeout(() => {
                btn.previousElementSibling.value = btn.previousElementSibling.getAttribute("data-code");
                btn.dataset.copied = "false";
                btn.style.pointerEvents = "auto";
                window.getSelection()?.removeAllRanges();
            }, 2000);
            })
            .catch((err) => {
            console.error("Failed to copy coupon code: ", err);
            });
        });
    });
    }
}

function handleBundleCards(){
    function startsWith(array, key) {
        const matcher = new RegExp(`^${key}`, 'g');
        return array.filter(word => word.match(matcher));
    }

    var bundleCouponContainers = document.getElementsByClassName('bundle-coupon-container');
    var bundlePricingCosts = document.getElementsByClassName('bundle-pricing-cost');
    var bundlePricingFullCosts = document.getElementsByClassName('bundle-pricing-full-cost');
    var bundlePricingDurations = document.getElementsByClassName('bundle-pricing-duration');
    var bundlePricingBuyLinks = document.getElementsByClassName('bundle-pricing-buy-link');
    
    if(bundleCouponContainers.length > 0){
        for(var i=0; i<bundleCouponContainers.length; i++){
            var singleCouponContainer = bundleCouponContainers[i];
            var allTags = singleCouponContainer.getAttribute('data-tags').split('|');
            var couponDetails = startsWith(allTags,"#coupon-")[0];
                couponDetails = couponDetails.replace('#coupon-','');
                var [code, description] = couponDetails.split('~');
                singleCouponContainer.querySelector(".bundle-coupon-code").innerHTML = code;
                singleCouponContainer.querySelector(".bundle-coupon-code").setAttribute("data-coupon",code);
                singleCouponContainer.querySelector(".bundle-coupon-description").innerHTML = description;
            
        }
    }

    if(bundlePricingCosts.length > 0){
        for(var i=0; i<bundlePricingCosts.length; i++){
            var singlePricingCost = bundlePricingCosts[i];
            var allTags = singlePricingCost.getAttribute('data-tags').split('|');
            var price = startsWith(allTags,"#price-")[0];
            price = "$"+price.replace('#price-','');
            singlePricingCost.innerHTML=price;
        }
    }

    if(bundlePricingFullCosts.length > 0){
        for(var i=0; i<bundlePricingFullCosts.length; i++){
            var singlePricingFullCost = bundlePricingFullCosts[i];
            var allTags = singlePricingFullCost.getAttribute('data-tags').split('|');
            var fullPrice = startsWith(allTags,"#full-price-")[0];
            if(fullPrice){
                fullPrice = "$"+fullPrice.replace('#full-price-','');
                singlePricingFullCost.innerHTML=fullPrice;
            } else {
                singlePricingFullCost.style.display = "none";
            }
            
        }
    }

    if(bundlePricingDurations.length > 0){
        for(var i=0; i<bundlePricingDurations.length; i++){
            var singlePricingDuration = bundlePricingDurations[i];
            var allTags = singlePricingDuration.getAttribute('data-tags').split('|');
            var duration = startsWith(allTags,"#duration-")[0];
            duration = "/"+duration.replace('#duration-','');
            singlePricingDuration.innerHTML=duration;
        }
    }

    if(bundlePricingBuyLinks.length > 0){
        for(var i=0; i<bundlePricingBuyLinks.length; i++){
            var singleBuyLink = bundlePricingBuyLinks[i];
            var allTags = singleBuyLink.getAttribute('data-tags').split('|');
            var buyLink = startsWith(allTags,"#buy-link-")[0];
            buyLink = buyLink.replace('#buy-link-','');
            singleBuyLink.href=buyLink;
        }
    }

}

function handleHostingCards(){
    function startsWith(array, key) {
        const matcher = new RegExp(`^${key}`, 'g');
        return array.filter(word => word.match(matcher));
    }

    var hostingPrice = document.getElementsByClassName('hosting-price');
    var hostingDuration = document.getElementsByClassName('hosting-duration');
    var hostingTutorialLink = document.getElementsByClassName('hosting-tutorial-link');
    var hostingBuyLink = document.getElementsByClassName('hosting-buy-link');
    var hostingFeatures = document.getElementsByClassName('hosting-features');
    
    

    if(hostingPrice.length > 0){
        for(var i=0; i<hostingPrice.length; i++){
            var singlePricingCost = hostingPrice[i];
            var allTags = singlePricingCost.getAttribute('data-tags').split('|');
            var price = startsWith(allTags,"#price-")[0];
            if(price === '#price-0') {
                price = 'FREE';
                hostingDuration[i].style.display = "none";
            } else {
                price = "$"+price.replace('#price-','');
            }
            singlePricingCost.innerHTML=price;
        }
    }

    if(hostingTutorialLink.length > 0){
        for(var i=0; i<hostingTutorialLink.length; i++){
            var singleBuyLink = hostingTutorialLink[i];
            var allTags = singleBuyLink.getAttribute('data-tags').split('|');
            var buyLink = startsWith(allTags,"#tutorial-")[0];
            if(buyLink){
                buyLink = buyLink.replace('#tutorial-','');
                singleBuyLink.href=buyLink;
            } else {
                singleBuyLink.style.display = "none";
            }
        }
    }

    if(hostingBuyLink.length > 0){
        for(var i=0; i<hostingBuyLink.length; i++){
            var singleBuyLink = hostingBuyLink[i];
            var allTags = singleBuyLink.getAttribute('data-tags').split('|');
            var buyLink = startsWith(allTags,"#buy-")[0];
            if(buyLink){
                buyLink = buyLink.replace('#buy-','');
                singleBuyLink.href=buyLink;
            } else {
                singleBuyLink.style.display = "none";
            }
        }
    }

    if(hostingFeatures.length > 0){
        for(var i=0; i<hostingFeatures.length; i++){
            var singleHostingFeatures = hostingFeatures[i];
            var allTags = singleHostingFeatures.getAttribute('data-tags').split('|');
            var features = startsWith(allTags,"#feature-");
            var featuresHTML = '';
            if(features.length > 0){
                for(var j=0; j<features.length; j++){
                    featuresHTML = featuresHTML + `<li class="flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="object-center object-contain filter-green icon icon-tabler icons-tabler-outline icon-tabler-checkbox">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M9 11l3 3l8 -8" />
                                            <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" />
                                        </svg>
                                        <div class="text-secondary">`+features[j].replace('#feature-','')+`</div>
                                    </li>`;
                }
                singleHostingFeatures.innerHTML = featuresHTML;
            } else {
                singleHostingFeatures.style.display = "none";
            }
        }
    }


}

function handleExpertCards(){
    function startsWith(array, key) {
        const matcher = new RegExp(`^${key}`, 'g');
        return array.filter(word => word.match(matcher));
    }

    var expertHourlyRate = document.getElementsByClassName('expert-hourly-rate');
    var expertContactLink = document.getElementsByClassName('expert-contact-link');
    var expertRateDuration = document.getElementsByClassName('expert-rate-duration');

    if(expertHourlyRate.length > 0){
        for(var i=0; i<expertHourlyRate.length; i++){
            var singleHourlyRate = expertHourlyRate[i];
            var singleExpertRateDuration = expertRateDuration[i];
            var allTags = singleHourlyRate.getAttribute('data-tags').split('|');
            var rate = startsWith(allTags,"#hourly-")[0];
            if(rate){
                rate = "$"+rate.replace('#hourly-','');
                singleHourlyRate.innerHTML=rate;
            } else {
                singleHourlyRate.style.display="none";
                singleExpertRateDuration.style.display="none";
            }
        }
    }

    if(expertContactLink.length > 0){
        for(var i=0; i<expertContactLink.length; i++){
            var singleContactLink = expertContactLink[i];
            var allTags = singleContactLink.getAttribute('data-tags').split('|');
            var contactLink = startsWith(allTags,"#contact-link-")[0];
            contactLink = contactLink.replace('#contact-link-','');
            singleContactLink.href=contactLink;
        }
    }
}

function addBundleCardEvents(){
    [...document.querySelectorAll('.bundle-coupon-code')].forEach(function(item) {
        item.addEventListener('click', function() {
          navigator.clipboard
                .writeText(item.getAttribute("data-coupon"))
                .then(() => {
                    item.dataset.copied = "true";
                    item.style.pointerEvents = "none";
                    item.innerHTML = 'Copied!';
                setTimeout(() => {
                    item.innerHTML = item.getAttribute("data-coupon");
                    item.dataset.copied = "false";
                    item.style.pointerEvents = "auto";
                    window.getSelection()?.removeAllRanges();
                }, 2000);
                })
                .catch((err) => {
                console.error("Failed to copy coupon code: ", err);
                });
        });
    });
}

function handleProductCards() {
    function startsWith(array, key) {
        const matcher = new RegExp(`^${key}`, 'g');
        return array.filter(word => word.match(matcher));
    }

    var anchorTags = document.getElementsByClassName('product-buy-link-card');
    var livePreviewContainers = document.getElementsByClassName('product-demo-card');
    var productSalePriceContainers = document.getElementsByClassName('product-sale-price-card');
    var productFullPriceContainers = document.getElementsByClassName('product-full-price-card');

    if(anchorTags.length > 0) {
        for(var i=0; i<anchorTags.length; i++){
            var anchorTag = anchorTags[i];
            var allTags = anchorTag.getAttribute('data-tags').split('|');
            var buyLink = startsWith(allTags,"#buy-link-")[0];
            if(buyLink){
                buyLink = buyLink.replaceAll("#buy-link-","");
                anchorTag.href=buyLink
            }
        }
    }

    if(productSalePriceContainers.length > 0) {
        for(var i=0; i<productSalePriceContainers.length; i++){
            var container = productSalePriceContainers[i];
            var fullPriceContainer = productFullPriceContainers[i];
            var allTags = container.getAttribute('data-tags').split('|');
            var salePrice = startsWith(allTags,"#sale-price-")[0];
            var fullPrice = startsWith(allTags,"#full-price-")[0];

            if(salePrice){
                salePrice = salePrice.replaceAll("#sale-price-","");
                if(salePrice === '0'){
                    container.innerHTML='FREE';
                } else {
                    container.innerHTML='$'+salePrice;
                }
            }

            if(fullPrice){
                fullPrice = fullPrice.replaceAll("#full-price-","");
                if(fullPrice === salePrice){
                    fullPriceContainer.style.display="none";
                } else if(fullPrice === '0'){
                    fullPriceContainer.innerHTML='FREE';
                } else {
                    fullPriceContainer.innerHTML='$'+fullPrice;
                }
            } else {
                fullPriceContainer.style.display="none";
            }

        }
    }

    /*if(productFullPriceContainers.length > 0) {
        for(var i=0; i<productFullPriceContainers.length; i++){
            var container = productFullPriceContainers[i];
            var allTags = container.getAttribute('data-tags').split('|');
            var fullPrice = startsWith(allTags,"#full-price-")[0];
            if(fullPrice){
                fullPrice = fullPrice.replaceAll("#full-price-","");
                if(fullPrice === '0'){
                    container.innerHTML='FREE';
                } else {
                    container.innerHTML='$'+fullPrice;
                }
            } else {
                container.style.display="none";
            }
        }
    }*/

    if(livePreviewContainers.length > 0) {
        for(var i=0; i<livePreviewContainers.length; i++){
            var container = livePreviewContainers[i];
            var allTags = container.getAttribute('data-tags').split('|');
            var isIframe = container.getAttribute('data-iframe');
            var demoLink = startsWith(allTags,"#demo-")[0];
            var buyLink = startsWith(allTags,"#buy-link-")[0];
            var demoSalePrice = startsWith(allTags,"#sale-price-")[0];
            if(demoSalePrice){
                demoSalePrice = demoSalePrice.replaceAll("#sale-price-","");
            }
            var demoFullPrice = startsWith(allTags,"#full-price-")[0];
            if(demoFullPrice){
                demoFullPrice = demoFullPrice.replaceAll("#full-price-","");
            }
            demoSalePrice = '$'+demoSalePrice;
            demoSalePrice = demoSalePrice.replaceAll('$0', 'FREE');
            demoFullPrice = '$'+demoFullPrice;
            demoFullPrice = demoFullPrice.replaceAll('$0', 'FREE');
            if(demoLink){
                demoLink = demoLink.replaceAll("#demo-","");
                if(buyLink){
                    buyLink = buyLink.replaceAll("#buy-link-","");
                }
                container.setAttribute('data-url', demoLink);
                container.setAttribute('data-sale-price', demoSalePrice);
                container.setAttribute('data-full-price', demoFullPrice);
                container.setAttribute('data-buy-link', buyLink);

                container.addEventListener("click", function(){
                    localStorage.setItem("live-preview-url",this.getAttribute('data-url'));
                    localStorage.setItem("live-preview-name",this.getAttribute('data-name'));
                    localStorage.setItem("live-preview-sale-price",this.getAttribute('data-sale-price'));
                    localStorage.setItem("live-preview-buy-link",this.getAttribute('data-buy-link'));
                    if(isIframe != 'false'){
                        window.open('/live-preview/', '_blank').focus();
                    }
                });
            } else {
                container.style.display = "none";
            }
        }
    }
}

function handleProductPage(){
    function startsWith(array, key) {
        const matcher = new RegExp(`^${key}`, 'g');
        return array.filter(word => word.match(matcher));
    }
    const productRawData = document.getElementById('product-dynamic-data');
    if(productRawData){
        var internalTags = productRawData.getAttribute('data-internal-tags').split('|');

        const couponContainer = document.getElementById("coupon-container");
        const couponDisclaimer = document.getElementById("coupon-disclaimer");
        const couponNotFound = document.getElementById("coupon-not-found");
        const featuresContainer = document.getElementById("features-container");
        const customBuyButton = document.getElementById('buy-custom-button');
        const themeforestBuyButton = document.getElementById('buy-themeforest-button');
        const lemonsqueezyBuyButton = document.getElementById('buy-lemonsqueezy-button');
        const gumroadBuyButton = document.getElementById('buy-gumroad-button');
        const bundleBuyButton = document.getElementById('buy-bundle-button');
        const bundleBuyDivider = document.getElementById('buy-bundle-divider');
        const freeDownloadButton = document.getElementById('free-download-button');
        const upsellContainer = document.getElementById('upsell-container');
        const upsellSectionContainer = document.getElementById('upsell-section-container');
        var productSalePriceContainers = document.getElementsByClassName('product-sale-price-card');
        var productFullPriceContainers = document.getElementsByClassName('product-full-price-card');
        

        const documentationButton = document.getElementById('documentation-link');
        const changelogButton = document.getElementById('changelog-link');
        const supportButton = document.getElementById('support-link');

        var features = [];
        var upsells = [];
        var coupons = {};
        var couponsHTML = '';
        var featuresHTML = '';
        
        var buyThemeForestLink = '';
        var buyGumroadLink = '';
        var buyLemonSqueezyLink = '';
        var buyBundleLink = '';
        var buyCustomLink = '';
        var freeDownloadLink = '';

        var jsonLdBuyLink = '';
        var jsonLdSalePrice = '';
        var jsonLdFullPrice = '';
        var jsonLdRating = '';

        var documentationLink = '';
        var changelogLink = '';
        var supportLink = '';
        
        var upSellThemeSlugs = [];

        function isEmpty(obj) {
            for (var o in obj)
              if (o) return false;
            return true;
          }

        if(internalTags){
            for(var i=0; i<internalTags.length; i++){
                var currentInternalTag = internalTags[i];
                if(currentInternalTag.startsWith("#coupon-")){
                    currentInternalTag = currentInternalTag.replace('#coupon-','');
                    var [code, description] = currentInternalTag.split('~');
                    coupons[code] = description;
                }
                if(currentInternalTag.startsWith("#upsell-")){
                    currentInternalTag = currentInternalTag.replace('#upsell-','');
                    upsells.push(currentInternalTag);
                }
                if(currentInternalTag.startsWith("#feature-")){
                    currentInternalTag = currentInternalTag.replace('#feature-','');
                    features.push(currentInternalTag);
                }
                if(currentInternalTag.startsWith("#buy-themeforest-")){
                    currentInternalTag = currentInternalTag.replace('#buy-themeforest-','');
                    buyThemeForestLink = currentInternalTag;
                }
                if(currentInternalTag.startsWith("#buy-lemonsqueezy-")){
                    currentInternalTag = currentInternalTag.replace('#buy-lemonsqueezy-','');
                    buyLemonSqueezyLink = currentInternalTag;
                }
                if(currentInternalTag.startsWith("#buy-gumroad-")){
                    currentInternalTag = currentInternalTag.replace('#buy-gumroad-','');
                    buyGumroadLink = currentInternalTag;
                }
                if(currentInternalTag.startsWith("#buy-bundle-")){
                    currentInternalTag = currentInternalTag.replace('#buy-bundle-','');
                    buyBundleLink = currentInternalTag;
                }
                if(currentInternalTag.startsWith("#buy-custom-")){
                    currentInternalTag = currentInternalTag.replace('#buy-custom-','');
                    buyCustomLink = currentInternalTag;
                }
                if(currentInternalTag.startsWith("#free-download-")){
                    currentInternalTag = currentInternalTag.replace('#free-download-','');
                    freeDownloadLink = currentInternalTag;
                }

                if(currentInternalTag.startsWith("#documentation-")){
                    currentInternalTag = currentInternalTag.replace('#documentation-','');
                    documentationLink = currentInternalTag;
                }

                if(currentInternalTag.startsWith("#changelog-")){
                    currentInternalTag = currentInternalTag.replace('#changelog-','');
                    changelogLink = currentInternalTag;
                }

                if(currentInternalTag.startsWith("#support-")){
                    currentInternalTag = currentInternalTag.replace('#support-','');
                    supportLink = currentInternalTag;
                }

                if(currentInternalTag.startsWith("#rating-")){
                    currentInternalTag = currentInternalTag.replace('#rating-','');
                    jsonLdRating = currentInternalTag;
                }
            }
        }

        if(!isEmpty(coupons)){
            for (var i in coupons) {
                couponsHTML = couponsHTML + `<div class="">
                                    <div class="text-xs text-secondary mb-0.5">
                                        `+coupons[i]+`
                                    </div>
                                    <div class="flex items-center">
                                        <input type="text" class="w-full text-sm xs:text-base py-2 px-4 bg-transparent text-primary border border-r-0 border-dashed border-theme rounded-l-custom font-bold outline-none" readonly placeholder="" title="Coupon code" value="`+i+`" data-code="`+i+`"/>
                                        <button type="button" title="Copy coupon code" data-copied="false" class="text-sm xs:text-base rounded-r-custom flex-shrink-0 bg-accent text-white font-bold flex items-center justify-center h-[2.375rem] xs:h-[2.625rem] aspect-square group coupon-code-btn">
                                            <img src="/assets/img/copy.svg" alt="icon" aria-hidden="true" class="size-1/2 object-contain object-center filter-light group-data-[copied='true']:hidden" />
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-1/2 object-contain object-center filter-light group-data-[copied='false']:hidden icon icon-tabler icons-tabler-outline icon-tabler-checkbox">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                <path d="M9 11l3 3l8 -8" />
                                                <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>`;
            } 
            
            if(couponContainer) couponContainer.innerHTML = couponsHTML;
            handleCouponCodes();
        } else {
            if(couponContainer) couponContainer.style.display = "none";
            if(couponDisclaimer) couponDisclaimer.style.display = "none";
            if(couponNotFound) couponNotFound.style.display = "flex";
        }

        if(upsells.length > 0){
            const api = new GhostContentAPI({
                url: GLOBAL.GHOST_URL,
                key: GLOBAL.GHOST_KEY,
                version: GLOBAL.GHOST_VERSION
            });
            var searchFilter = "";
            
            for(var i=0; i<upsells.length; i++){
                 upSellThemeSlugs.push(upsells[i]);
            }
            if(upsells.length > 0){
                searchFilter = "slug:["+upSellThemeSlugs+"]";
            }
            //if(featuresContainer) featuresContainer.innerHTML = featuresHTML;

            api.posts
                .browse({
                    include: 'tags,authors',
                    filter: searchFilter
                })
                .then((posts) => {
                    const totalElements = posts.meta.pagination.total;
                    const productListGrid = document.getElementById("upsell-container");
                    productListGrid.innerHTML = "";//clear the grid
                    if(totalElements < 1){
                       // console.log("No Upsells Found!");
                    } else {
                        const productTemplate = document.getElementById("template-product-card");

                        posts.forEach((post) => {
                            const clone = document.importNode(productTemplate.content, true);
                            var title = post.title;
                            var feature_image = post.feature_image;
                            feature_image = feature_image.replace("content/images/","content/images/size/w400/format/webp/");
                            var featured = post.featured;
                            var url = post.url;
                            var tags = post.tags;
                            var tagNames = [];
                            var isCoupon = false;
                            var salePrice = '';
                            var fullPrice = '';
                            var authorImage = post.authors[0].profile_image;
                            authorImage = authorImage.replace("content/images/","content/images/size/w50/format/webp/");
                            var authorVerified = post.authors[0].facebook;
                            var authorName = post.authors[0].name;
                            var authorUrl = post.authors[0].url;
                            var rating = '';
                            var yellowStar = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="filter-yellow size-3 object-contain object-center icon icon-tabler icons-tabler-filled icon-tabler-star">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path d="M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z" />
                                                </svg>`;
                            var greyStar = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="filter-theme size-3 object-contain object-center icon icon-tabler icons-tabler-outline icon-tabler-star">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" />
                                            </svg>`;

                            for(var i=0; i < tags.length; i++){
                                var tagName = tags[i].name;
                                tagNames.push(tagName);
                                if(tagName.startsWith("#sale-price-")){
                                    salePrice = '$'+tagName.replace('#sale-price-','');
                                    salePrice = salePrice.replace('$0','FREE');
                                }
                                if(tagName.startsWith("#full-price-")){
                                    fullPrice = '$'+tagName.replace('#full-price-','');
                                    fullPrice = fullPrice.replace('$0','FREE');
                                }
                                if(tagName.startsWith("#rating-")){
                                    rating = tagName.replace('#rating-','');
                                }
                            }
                            var ratingStars ='';
                            for(var j=0; j<rating; j++){
                                ratingStars = ratingStars + yellowStar;
                            }
                            for(var k=5; k>rating; k--){
                                ratingStars = ratingStars + greyStar;
                            }
                            if(tagNames.includes("#coupons")){
                                isCoupon = true;
                            }

                            clone.getElementById("product-title").innerHTML = title;
                            //clone.getElementById("product-url-sr").href = url;
                            clone.getElementById("product-url").href = url;
                            clone.getElementById("product-rating").innerHTML = ratingStars;
                            if(authorImage){
                                clone.getElementById("product-author-image").src = authorImage;
                            } else {
                                clone.getElementById("product-author-image").style.display = 'none';
                            }

                            if(authorVerified){
                                clone.getElementById("product-author-verified").style.display = 'flex';
                            } else {
                                clone.getElementById("product-author-verified").style.display = 'none';
                            }
                            
                            clone.getElementById("product-author-name").innerHTML = `<a href="`+authorUrl+`">`+authorName+`</a>`;
                            clone.getElementById("product-sale-price").innerHTML = salePrice;
                            if(fullPrice && fullPrice!==salePrice){
                                clone.getElementById("product-full-price").innerHTML = fullPrice;
                            } else {
                                clone.getElementById("product-full-price").style.display = "none";
                            }

                            clone.getElementById("product-image").src = feature_image;
                            if(isCoupon){
                                clone.getElementById("product-discount").style.display = 'flex'
                            } else {
                                clone.getElementById("product-discount").style.display = 'none'
                            }
                            if(featured){
                                clone.getElementById("product-featured").style.display = 'flex'
                            } else {
                                clone.getElementById("product-featured").style.display = 'none'
                            }
                            productListGrid.appendChild(clone);
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                });


        } else {
            if(upsellContainer) upsellContainer.style.display = "none";
            if(upsellSectionContainer) upsellSectionContainer.style.display = "none";
        }

        if(features.length > 0){
            for(var i=0; i<features.length; i++){
                featuresHTML = featuresHTML + `<li class="flex items-center gap-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4 object-center object-contain filter-green icon icon-tabler icons-tabler-outline icon-tabler-checkbox">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M9 11l3 3l8 -8" />
                            <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" />
                        </svg>
                        <div class="text-secondary text-sm">`+features[i]+`</div>
                    </li>`;
            }
            if(featuresContainer) featuresContainer.innerHTML = featuresHTML;
        } else {
            if(featuresContainer) featuresContainer.style.display = "none";
        }

        if(buyCustomLink) {
            customBuyButton.href=buyCustomLink;
            customBuyButton.style.display="flex";
            jsonLdBuyLink=buyCustomLink;
        }

        if(freeDownloadLink) {
            freeDownloadButton.href=freeDownloadLink;
            freeDownloadButton.style.display="flex";
            jsonLdBuyLink=freeDownloadLink;
        }

        if(buyThemeForestLink) {
            themeforestBuyButton.href=buyThemeForestLink;
            themeforestBuyButton.style.display="flex";
            jsonLdBuyLink=buyThemeForestLink;
        }

        if(buyLemonSqueezyLink) {
            lemonsqueezyBuyButton.href=buyLemonSqueezyLink;
            lemonsqueezyBuyButton.style.display="flex";
            jsonLdBuyLink=buyLemonSqueezyLink;
        }

        if(buyGumroadLink) {
            gumroadBuyButton.href=buyGumroadLink;
            gumroadBuyButton.style.display="flex";
            jsonLdBuyLink=buyGumroadLink;
        }

        if(buyBundleLink) {
            bundleBuyButton.href=buyBundleLink;
            bundleBuyButton.style.display="flex";
            bundleBuyDivider.style.display="block";
        }

        if(documentationLink) {
            documentationButton.href=documentationLink;
            documentationButton.style.display="flex";
        }
        if(changelogLink) {
            changelogButton.href=changelogLink;
            changelogButton.style.display="flex";
        }
        if(supportLink) {
            supportButton.href=supportLink;
            supportButton.style.display="flex";
        }

        if(documentationLink || changelogLink || supportLink){
            var dividers = document.getElementsByClassName('if-secondary-links');
            for(var i=0; i<dividers.length; i++){
                dividers[i].style.display = 'flex';
            }
        }

        const livePreviewBtn = document.getElementById('live-preview-product-page-external-link');
        if(livePreviewBtn){
            var buyLink = livePreviewBtn.getAttribute("data-buy-link");
            var livePreviewLink = livePreviewBtn.getAttribute("data-url");
            livePreviewBtn.addEventListener('click', function(){
                window.open(buyLink, "_blank");
                window.open(livePreviewLink, "_blank");
            });
        }

        if(productSalePriceContainers.length > 0) {
            var finalJsonLdSalePrice;
            for(var i=0; i<productSalePriceContainers.length; i++){
                var container = productSalePriceContainers[i];
                var allTags = container.getAttribute('data-tags').split('|');
                jsonLdSalePrice = startsWith(allTags,"#sale-price-")[0];
                if(jsonLdSalePrice && i===0){
                    jsonLdSalePrice = jsonLdSalePrice.replaceAll("#sale-price-","");
                    finalJsonLdSalePrice = jsonLdSalePrice;
                 } 
                }
            }
    
    
    if(productFullPriceContainers.length > 0) {
        var finalJsonLdFullPrice;
            for(var i=0; i<productFullPriceContainers.length; i++){
                var container = productFullPriceContainers[i];
                var allTags = container.getAttribute('data-tags').split('|');
                jsonLdFullPrice = startsWith(allTags,"#full-price-")[0];
                if(jsonLdFullPrice && i===0){
                    jsonLdFullPrice = jsonLdFullPrice.replaceAll("#full-price-","");
                    finalJsonLdFullPrice = jsonLdFullPrice;
                } 
            }
        }


        var data = `,
                    "offers": {
                        "@type": "AggregateOffer",
                        "url": "`+jsonLdBuyLink+`",
                        "priceCurrency": "USD",
                        "lowPrice": "`+finalJsonLdSalePrice+`",
                        "highPrice": "`+finalJsonLdFullPrice+`",
                        "offerCount": "1"
                    },
                    "aggregateRating": {
                        "@type": "AggregateRating",
                        "ratingValue": "`+jsonLdRating+`",
                        "bestRating": "5",
                        "worstRating": "0",
                        "ratingCount": "1"
                    }`;

        var JSONLD = document.getElementById("JSONLD").innerHTML;
        var dynamicJSONLD = "{"+JSONLD + data+"}";

            const script = document.createElement('script');
            script.setAttribute('type', 'application/ld+json');
            script.textContent = dynamicJSONLD;
            document.head.appendChild(script);
    }

} 

//Handle Filter
function handleFilter() {
    //Filter
    const filter = document.getElementById("filter");
    const closeFliterBtn = document.getElementById("close-filter-btn");
    const openFliterBtn = document.getElementById("open-filter-btn");
    const filterInputs = document.querySelectorAll(".filter-input");
    const clearFliterBtn = document.getElementById("clear-shop-filter");
    const submitFilterBtn = document.getElementById("submit-shop-filter");

    const closeFilter = () => {
    filter.dataset.open = "false";
    document.body.style.overflowY = "scroll";
    };
    const openFilter = () => {
    filter.dataset.open = "true";
    document.body.style.overflowY = "hidden";
    };

    if (filter) {
    closeFliterBtn.addEventListener("click", closeFilter);
    //openFliterBtn.addEventListener("click", openFilter);
    document.addEventListener("click", (e) => {
        if (!filter.contains(e.target)) {
            if (openFliterBtn && openFliterBtn.contains(e.target)) {
                openFilter();
            }
            else {
                closeFilter();
            }
        }
    });
    clearFliterBtn.addEventListener("click", () => {
        window.location.reload();
    });
    }

    if(submitFilterBtn){
            const api = new GhostContentAPI({
                url: GLOBAL.GHOST_URL,
                key: GLOBAL.GHOST_KEY,
                version: GLOBAL.GHOST_VERSION
            });

        submitFilterBtn.addEventListener("click", function(){
            submitFilterBtn.innerHTML='Please wait!';
            submitFilterBtn.disabled = true;
            submitFilterBtn.style.cursor = 'not-allowed';

            var filters = document.getElementsByClassName("filter-input");
            var developerFilters = document.getElementsByClassName("developer-filter-input");
            var featureFilters = document.getElementsByClassName("feature-filter-input");
            var priceFilters = document.getElementsByClassName("price-filter-input");
            var ratingFilters = document.getElementsByClassName("rating-filter-input");
            var useCaseFilters = document.getElementsByClassName("use-case-filter-input");

            var searchFilter = "";
            var filterTags = [];
            var filterAuthors = [];
            var filterFeatures = [];
            var filterPrices = [];
            var filterRatings = [];
            var filterUseCases = [];
            var tagFilters = "";
            var authorFilters = "";
            var featureTagFilters = "";
            var priceTagFilters = "";
            var ratingTagFilters = "";
            var useCaseTagFilters = "";
            
            for(var i=0; i < filters.length; i++){
                var filter = filters[i];
                if(filter.checked){
                    filterTags.push(filter.getAttribute("data-filter"));
                }
            }

            for(var i=0; i < developerFilters.length; i++){
                var developerFilter = developerFilters[i];
                if(developerFilter.checked){
                    filterAuthors.push(developerFilter.getAttribute("data-filter"));
                }
            }

            for(var i=0; i < featureFilters.length; i++){
                var featureFilter = featureFilters[i];
                if(featureFilter.checked){
                    filterFeatures.push(featureFilter.getAttribute("data-filter"));
                }
            }

            for(var i=0; i < priceFilters.length; i++){
                var priceFilter = priceFilters[i];
                if(priceFilter.checked){
                    filterPrices.push(priceFilter.getAttribute("data-filter"));
                }
            }

             for(var i=0; i < ratingFilters.length; i++){
                 var ratingFilter = ratingFilters[i];
                 if(ratingFilter.checked){
                     filterRatings.push(ratingFilter.getAttribute("data-filter"));
                 }
             }

            for(var i=0; i < useCaseFilters.length; i++){
                var useCaseFilter = useCaseFilters[i];
                if(useCaseFilter.checked){
                    filterUseCases.push(useCaseFilter.getAttribute("data-filter"));
                }
            }

            if(filterTags.length < 1 && filterAuthors.length < 1 && filterFeatures.length < 1 && filterPrices.length < 1 && filterRatings.length < 1 && filterUseCases.length < 1){
                document.getElementById('no-filter-message').style.display="flex";
                setTimeout(function(){
                    document.getElementById('no-filter-message').style.display="none";
                  },3000);
                
                submitFilterBtn.innerHTML='Filter results';
                submitFilterBtn.disabled = false;
                submitFilterBtn.style.cursor = 'pointer';
            } else {
                document.getElementById('no-filter-message').style.display="none";

                if(filterTags.length > 0){
                    tagFilters = "tag:[hash-product]+tag:["+filterTags.toString()+"]";
                } else {
                    tagFilters = "tag:[hash-product]";
                }
                if(filterAuthors.length > 0){
                    authorFilters = "author:["+filterAuthors.toString()+"]";
                        authorFilters = "+"+authorFilters;
                }
                if(filterFeatures.length > 0){
                    featureTagFilters = "tag:["+filterFeatures.toString()+"]";
                    featureTagFilters = "+"+featureTagFilters;
                }
                if(filterPrices.length > 0){
                    priceTagFilters = "tag:["+filterPrices.toString()+"]";
                    priceTagFilters = "+"+priceTagFilters;
                }
                 if(filterRatings.length > 0){
                     ratingTagFilters = "tag:["+filterRatings.toString()+"]";
                     ratingTagFilters = "+"+ratingTagFilters;
                 }
                if(filterUseCases.length > 0){
                    useCaseTagFilters = "tag:["+filterUseCases.toString()+"]";
                    useCaseTagFilters = "+"+useCaseTagFilters;
                }
                
                searchFilter = tagFilters+authorFilters+featureTagFilters+priceTagFilters+ratingTagFilters+useCaseTagFilters;
                //searchFilter = tagFilters+authorFilters+featureTagFilters+priceTagFilters+useCaseTagFilters;
    
                api.posts
                    .browse({
                        include: 'tags,authors',
                        filter: searchFilter,
                        limit: "all"
                    })
                    .then((posts) => {
                        const totalElements = posts.meta.pagination.total;
    
                        const productListGrid = document.getElementById("product-list-grid");
                        const shopPageMessage = document.getElementById("shop-page-message");
                        const pagination = document.getElementById("pagination");
                        const themeCount = document.getElementById("theme-count");
                        const themePlural = document.getElementById("theme-plural");
                        
                        productListGrid.innerHTML = "";//clear the grid
                        if(totalElements < 1){
                            productListGrid.style.display = 'none';
                            pagination.style.display = 'none';
                            shopPageMessage.style.display = 'flex';
                            themeCount.innerHTML = "Zero";
                            themePlural.style.display = "inline";
                            
                            shopPageMessage.innerHTML = `<div class="text-primary border border-theme rounded-custom p-6 md:px-8 lg:px-10 xl:px-12 md:py-11 lg:py-16 flex flex-col gap-4 md:gap-6 lg:gap-8">
                                                        <h3 class="text-2xl xs:text-3xl xl:text-4xl font-heading font-bold">
                                                            No themes found!
                                                        </h3>
                                                        <p class="xl:text-lg">
                                                            There are no themes that match your search filters. Please try removing some filters or clear all filters to see all themes.
                                                        </p>
                                                        <a href="#" onclick="window.location.reload(true);" class="mt-auto button border border-theme text-center font-bold xs:px-12 xl:py-3 w-full xs:w-max">
                                                            Clear all filters
                                                        </a>
                                                        </div>`;
                            
                        } else {
                            productListGrid.style.display = 'grid';
                            pagination.style.display = 'none';
                            shopPageMessage.style.display = 'none';
                            themeCount.innerHTML = totalElements;
                            if(totalElements == 1){
                                themePlural.style.display = "none";
                            } else {
                                themePlural.style.display = "inline";
                            }
    
                            const productTemplate = document.getElementById("template-product-card");
    
                            posts.forEach((post) => {
                                const clone = document.importNode(productTemplate.content, true);
                                var title = post.title;
                                var feature_image = post.feature_image;
                                feature_image = feature_image.replace("content/images/","content/images/size/w400/format/webp/");
                                var featured = post.featured;
                                var url = post.url;
                                var tags = post.tags;
                                var tagNames = [];
                                var isCoupon = false;
                                var salePrice = '';
                                var fullPrice = '';
                                var authorImage = post.authors[0].profile_image;
                                authorImage = authorImage.replace("content/images/","content/images/size/w50/format/webp/");
                                var authorVerified = post.authors[0].facebook;
                                var authorName = post.authors[0].name;
                                var authorUrl = post.authors[0].url;
                                var rating = '';
                                var yellowStar = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="filter-yellow size-3 object-contain object-center icon icon-tabler icons-tabler-filled icon-tabler-star">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path d="M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z" />
                                                </svg>`;
                                var greyStar = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="filter-theme size-3 object-contain object-center icon icon-tabler icons-tabler-outline icon-tabler-star">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" />
                                                </svg>`;
    
                                for(var i=0; i < tags.length; i++){
                                    var tagName = tags[i].name;
                                    tagNames.push(tagName);
                                    if(tagName.startsWith("#sale-price-")){
                                        salePrice = '$'+tagName.replace('#sale-price-','');
                                        salePrice = salePrice.replace('$0','FREE');
                                    }
                                    if(tagName.startsWith("#full-price-")){
                                        fullPrice = '$'+tagName.replace('#full-price-','');
                                        fullPrice = fullPrice.replace('$0','FREE');
                                    }
                                     if(tagName.startsWith("#rating-")){
                                         rating = tagName.replace('#rating-','');
                                     }
                                }
    
    
                                 var ratingStars ='';
                                 for(var j=0; j<rating; j++){
                                     ratingStars = ratingStars + yellowStar;
                                 }
                                 for(var k=5; k>rating; k--){
                                     ratingStars = ratingStars + greyStar;
                                 }
                                if(tagNames.includes("#coupons")){
                                    isCoupon = true;
                                }
    
                                clone.getElementById("product-title").innerHTML = title;
                                //clone.getElementById("product-url-sr").href = url;
                                clone.getElementById("product-url").href = url;
                                clone.getElementById("product-rating").innerHTML = ratingStars;
                                 if(authorImage){
                                     clone.getElementById("product-author-image").src = authorImage;
                                 } else {
                                     clone.getElementById("product-author-image").style.display = 'none';
                                 }
                                 if(authorVerified){
                                     clone.getElementById("product-author-verified").style.display = 'flex';
                                 } else {
                                     clone.getElementById("product-author-verified").style.display = 'none';
                                 }
                                
                                 clone.getElementById("product-author-name").innerHTML = `<a href="`+authorUrl+`">`+authorName+`</a>`;
                                
                                clone.getElementById("product-sale-price").innerHTML = salePrice;
                                if(fullPrice && fullPrice!==salePrice){
                                    clone.getElementById("product-full-price").innerHTML = fullPrice;
                                } else {
                                    clone.getElementById("product-full-price").style.display = "none";
                                }
                                clone.getElementById("product-image").src = feature_image;
                                 if(isCoupon){
                                     clone.getElementById("product-discount").style.display = 'flex'
                                 } else {
                                     clone.getElementById("product-discount").style.display = 'none'
                                 }
                                 if(featured){
                                     clone.getElementById("product-featured").style.display = 'flex'
                                 } else {
                                     clone.getElementById("product-featured").style.display = 'none'
                                 }
    
                                productListGrid.appendChild(clone);
                            });
                        }
    
                        if(closeFliterBtn){
                            closeFilter();
                        }

                        window.scrollTo(0, 100);

                        submitFilterBtn.innerHTML='Filter results';
                        submitFilterBtn.disabled = false;
                        submitFilterBtn.style.cursor = 'pointer';
                    })
                    .catch((err) => {
                        console.error(err);
                    });
                    
            }
        }
    );
    }
}

const handleSelectedFilters = () => {
    var checkboxes = document.querySelectorAll(".js-filter-input");
    var selectedFilterContainer = document.getElementById('selected-filters-container');

    if (checkboxes.length > 0) {
        checkboxes.forEach(function (checkbox) {
            checkbox.addEventListener("change", function () {
                var label = this.getAttribute("data-filter-name");
                if(this.checked){
                    selectedFilterContainer.innerHTML = selectedFilterContainer.innerHTML +
                    `<a href="#" data-filter-label="`+label+`" class="hover:border-red-hover bg-hero hover:bg-red border rounded-custom">
                        <div class="p-1 px-2 rounded-custom flex gap-2  text-secondary hover:text-primary">
                            <span class="content-center whitespace-nowrap">`+label+`</span>
                        </div>
                    </a>`;
                } else {
                    removeSelectedFiltersOnUncheck(selectedFilterContainer, "data-filter-label", label);
                }
            });
        });
    }

};

function removeSelectedFiltersOnUncheck(parent, attributeName, attributeValue) {
    const children = Array.from(parent.children);
    for (const child of children) {
      if (child.getAttribute(attributeName) === attributeValue) {
        parent.removeChild(child);
        return; // Stop after removing the first matching element
      }
    }
}

//Handle External links
const handleExternalLinks = () => {
    if (GLOBAL.OPEN_LINKS_IN_NEW_TAB) {
        const domain = location.host.replace("www.", "");
        const postLinks = document.querySelectorAll("body a");
        postLinks.forEach((link) => {
            const linkURL = link.href.includes("?ref=")
                ? link.href.split("?ref=")[0]
                : link.href;
            if (!linkURL.includes(domain)) {
                link.setAttribute("target", "_blank");
                link.setAttribute("rel", "noreferrer noopener nofollow");
            }
        });
    }
};

//Responsive Embeds
(function (global, factory) {
    typeof exports === "object" && typeof module !== "undefined"
        ? (module.exports = factory())
        : typeof define === "function" && define.amd
        ? define(factory)
        : ((global = global || self), (global.reframe = factory()));
})(this, function () {
    "use strict";

    function reframe(target, cName) {
        var frames =
            typeof target === "string"
                ? document.querySelectorAll(target)
                : target;
        var c = cName || "js-reframe";
        if (!("length" in frames)) frames = [frames];
        for (var i = 0; i < frames.length; i += 1) {
            var frame = frames[i];
            var hasClass = frame.className.split(" ").indexOf(c) !== -1;
            if (hasClass || frame.style.width.indexOf("%") > -1) continue;
            var h = frame.getAttribute("height") || frame.offsetHeight;
            var w = frame.getAttribute("width") || frame.offsetWidth;
            var padding = (h / w) * 100;
            var div = document.createElement("div");
            div.className = c;
            var divStyles = div.style;
            divStyles.position = "relative";
            divStyles.width = "100%";
            divStyles.paddingTop = padding + "%";
            var frameStyle = frame.style;
            frameStyle.position = "absolute";
            frameStyle.width = "100%";
            frameStyle.height = "100%";
            frameStyle.left = "0";
            frameStyle.top = "0";
            frame.parentNode.insertBefore(div, frame);
            frame.parentNode.removeChild(frame);
            div.appendChild(frame);
        }
    }

    return reframe;
});

const handleSearchFilterOption = () => {
    const searchFilterOptions = document.getElementsByClassName('js-search-filter-option');
    const searchResultsContainer = document.querySelector('.js-search-results');
    for (var i = 0; i < searchFilterOptions.length; i++) {
        searchFilterOptions[i].addEventListener("click", function(){
            var labelValue = this.querySelector('label').innerHTML.trim();
            document.querySelector('#ghost-search-field').value = "";
            searchResultsContainer.innerHTML = "";
            searchResultsContainer.insertAdjacentHTML(
                "beforeend",
                `<div class="w-full text-primary text-sm  py-2 px-4">Type to search</div>`
            );
            
            document.getElementById("search-scope").value = labelValue;
            document.getElementById("active-search-filter-nav").innerHTML = labelValue;

            if(labelValue === SEARCH_SCOPE_ALL_ITEMS){
                document.querySelector('#ghost-search-field').placeholder = "Themes, bundles, blog, and more...";    
            } else if(labelValue === SEARCH_SCOPE_THEMES){
                document.querySelector('#ghost-search-field').placeholder = "Type theme name to search...";    
            } else if(labelValue === SEARCH_SCOPE_THEME_BUNDLES){
                document.querySelector('#ghost-search-field').placeholder = "Type theme bundle by developer...";    
            } else if(labelValue === SEARCH_SCOPE_TUTORIALS){
                document.querySelector('#ghost-search-field').placeholder = "Type topic or keyword for tuorial...";    
            } else if(labelValue === SEARCH_SCOPE_HOSTING){
                document.querySelector('#ghost-search-field').placeholder = "Type hosting provider...";    
            } else if(labelValue === SEARCH_SCOPE_BLOG_ARTICLES){
                document.querySelector('#ghost-search-field').placeholder = "Type topic or keyword for blog...";    
            } else if(labelValue === SEARCH_SCOPE_DEVELOPERS){
                document.querySelector('#ghost-search-field').placeholder = "Type developer/agency name...";    
            } else if(labelValue === SEARCH_SCOPE_THEME_FEATURES){
                document.querySelector('#ghost-search-field').placeholder = "Type feature, like 'dark mode', etc...";    
            } else {
                document.querySelector('#ghost-search-field').placeholder = "Themes, bundles, blog, and more...";    
            } 

        });
    }
}

const handleSearch = () => {
    const searchForm = document.querySelector('.js-search-form');
    const searchField = document.querySelector('#ghost-search-field');
    const searchResultsContainer = document.querySelector('.js-search-results');
    var searchScope;

    if (searchField && searchForm) {
        searchField.onfocus = () => {
            if(searchField.value.length < 1){
                searchResultsContainer.innerHTML = "";
                searchResultsContainer.insertAdjacentHTML(
                    "beforeend",
                    `<div class="w-full text-primary text-sm  py-2 px-4">Type to search</div>`
                );
            }
            searchScope = document.getElementById("search-scope").value;
            prepareSearch(searchScope);
        };

        searchField.onkeyup = (e) => {
            e.preventDefault();
            if (e.target.value.length > 2) {
                performPostSearch(searchScope, e.target.value);
            } else {
                searchResultsContainer.innerHTML = "";
                searchResultsContainer.insertAdjacentHTML(
                    "beforeend",
                    `<div class="w-full text-primary text-sm  py-2 px-4">Type atleast 3 characters</div>`
                );
            }
        };

        searchForm.addEventListener('submit', (e) => {
            e.preventDefault();
        }, false);
    }
}
  
const prepareSearch = (searchScope) => {
    var searchFilter;
    const options = {
        shouldSort: true,
        tokenize: true,
        matchAllTokens: true,
        threshold: 0,
        maxPatternLength: 32,
        minMatchCharLength: 3,
        ignoreLocation: true,
        keys: ""
    }

    const api = new GhostContentAPI({
        url: GLOBAL.GHOST_URL,
        key: GLOBAL.GHOST_KEY,
        version: GLOBAL.GHOST_VERSION
    });

    if (searchScope === SEARCH_SCOPE_THEMES) {
        searchFilter = "tag:hash-product";
    } else if (searchScope === SEARCH_SCOPE_THEME_BUNDLES) {
        searchFilter = "tag:hash-bundle";
    } else if (searchScope === SEARCH_SCOPE_TUTORIALS) {
        searchFilter = "tag:hash-tutorial";
    } else if (searchScope === SEARCH_SCOPE_HOSTING) {
        searchFilter = "tag:hash-hosting";
    } else if (searchScope === SEARCH_SCOPE_BLOG_ARTICLES) {
        searchFilter = "tag:-[hash-product,hash-bundle,hash-tutorial,hash-hosting]";
    } else {
        searchFilter = "";
    }

    if (searchScope === SEARCH_SCOPE_DEVELOPERS) {
        if (GLOBAL.FUSEAUTHORS) return;
        const getAuthors = async function (filter, callback) {
            try {
                const authors = await api.authors.browse({
                    limit: 'all'
                });
                return authors;
            } catch (err) {
                console.log(err);
            }
        }
        getAuthors().then(function (authors) {
            const keys = [{ name: 'name' }, { name: 'slug' }, { name: 'bio' }, { name: 'website' }];
            options.keys = keys;
            GLOBAL.FUSEAUTHORS = new Fuse(authors, options);
        });
    } else if (searchScope === SEARCH_SCOPE_THEME_FEATURES || searchScope === SEARCH_SCOPE_THEME_USE_CASES) {
        if (GLOBAL.FUSETAGS) return;
        const getTags = async function (filter, callback) {
            try {
                const tags = await api.tags.browse({
                    limit: 'all',
                    filter: 'slug:[' + GLOBAL.PRODUCT_FEATURE_TAG_SLUGS + ',' + GLOBAL.PRODUCT_USE_CASE_TAG_SLUGS + ']'
                });
                return tags;
            } catch (err) {
                console.log(err);
            }
        }
        getTags().then(function (tags) {
            const keys = [{ name: 'name' }, { name: 'slug' }, { name: 'bio' }, { name: 'website' }];
            options.keys = keys;
            GLOBAL.FUSETAGS = new Fuse(tags, options);
        });
    } else {
        const getPosts = async function (filter, callback) {
            const fields = GLOBAL.GHOST_SEARCH_IN_CONTENT ? `url,slug,title,custom_excerpt,feature_image,plaintext` : `url,slug,title,custom_excerpt,feature_image`;
            const formats = GLOBAL.GHOST_SEARCH_IN_CONTENT ? ['html,plaintext'] : '';
            try {
                const posts = await api.posts.browse({
                    limit: 'all',
                    include: 'tags,authors',
                    fields: fields,
                    filter: filter,
                    formats: formats
                });
                return posts;
            } catch (err) {
                console.log(err);
            }
        }

        getPosts(searchFilter).then(function (posts) {
            const keys = GLOBAL.GHOST_SEARCH_IN_CONTENT ? [{ name: 'title' }, { name: 'tags.name' }, { name: 'custom_excerpt' }, { name: 'authors.name' }, { name: 'plaintext' }]
                : [{ name: 'title' }, { name: 'tags.name' }, { name: 'custom_excerpt' }, { name: 'authors.name' }];

            options.keys = keys;
            GLOBAL.FUSEPOSTS = new Fuse(posts, options);
        });
    }
}
  
const performPostSearch = (searchScope, query) => {
    var results;
    var searchResults;
    if (searchScope === SEARCH_SCOPE_DEVELOPERS) {
        results = GLOBAL.FUSEAUTHORS.search(query, { limit: GLOBAL.GHOST_SEARCH_LIMIT });
    } else if (searchScope === SEARCH_SCOPE_THEME_FEATURES || searchScope === SEARCH_SCOPE_THEME_USE_CASES) {
        results = GLOBAL.FUSETAGS.search(query, { limit: GLOBAL.GHOST_SEARCH_LIMIT });
    } else {
        results = GLOBAL.FUSEPOSTS.search(query, { limit: GLOBAL.GHOST_SEARCH_LIMIT });
    }
    const resultEl = document.querySelector('.js-search-results');

    if (results.length === 0) {
        resultEl.innerHTML = '<div class="w-full text-primary text-sm  py-2 px-4">No results found!</div>';
        return;
    }

    if (searchScope === SEARCH_SCOPE_DEVELOPERS) {

        searchResults = results.map(function (author) {
            const indexTitle = author.item.name.search(new RegExp(query, 'i'));

            // Highlight search in title
            const name = indexTitle > -1 
                ? `${author.item.name.substring(0, indexTitle)}<span class="font-bold">${author.item.name.substring(indexTitle, indexTitle + query.length)}</span>${author.item.name.substring(indexTitle + query.length, author.item.name.length)}`
                : author.item.name

            const profile_image = author.item.profile_image;
            const primary_tag = "Developer";
            const url = author.item.url;

            let start = 0, end = 100;
            let bio;

            // Highlight search in content
            if (GLOBAL.GHOST_SEARCH_IN_CONTENT && author.item.bio > 0) {
                const indexContent = author.item.bio.search(new RegExp(query, 'i'));

                if (indexContent > 50) {
                    start = indexContent - 50;
                    end = indexContent + 50;
                }

                bio = author.item.bio.substring(start, end);

                bio = indexContent > -1 
                    ? `...${author.item.bio.substring(start, indexContent)}<span class="font-bold">${author.item.bio.substring(indexContent, indexContent + query.length)}</span>${author.item.bio.substring(indexContent + query.length, end)}...`
                    : bio;
            } else {
                bio = author.item.bio ? author.item.bio.substring(start, end) : ''
            }
            //return `<img src="${profile_image}"> <a href="${url}" class="search-result w-full text-header text-sm py-2 px-4 outline-none focus:bg-header-hover hover:bg-header-hover">${name} - ${primary_tag} - ${bio}</a> `;
            return `<a href="${url}" class="search-result w-full p-2 outline-none focus:bg-header-hover hover:bg-header-hover grid grid-cols-[auto_4rem] gap-2">
                        <div class="grid grid-cols-[2.5rem_1fr] gap-2.5">
                            <div class="relative aspect-[2/3] w-full">
                                <img src="${profile_image}" class="absolute top-0 left-0 h-full w-full object-cover object-center rounded"/>
                            </div>
                            <div class="flex flex-col gap-1">
                                <div class="text-primary font-semibold text-base line-clamp-1">${name}</div>
                                <p class="text-primary text-xs line-clamp-2">
                                    ${bio}
                                </p>
                            </div>
                        </div>
                        <div class="flex items-center justify-center">
                            <div class="w-full relative flex items-center justify-center py-1 px-2 rounded-custom text-xs text-secondary border border-theme">
                                ${primary_tag}
                            </div>
                        </div>
                    </a>`;
        }).join(' ');

    } else if (searchScope === SEARCH_SCOPE_THEME_FEATURES || searchScope === SEARCH_SCOPE_THEME_USE_CASES) {

        searchResults = results.map(function (tag) {
            const indexTitle = tag.item.name.search(new RegExp(query, 'i'));

            // Highlight search in title
            const name = indexTitle > -1 
                ? `${tag.item.name.substring(0, indexTitle)}<span class="font-bold">${tag.item.name.substring(indexTitle, indexTitle + query.length)}</span>${tag.item.name.substring(indexTitle + query.length, tag.item.name.length)}`
                : tag.item.name

            const feature_image = tag.item.feature_image;
            const primary_tag = "Feature";
            const url = tag.item.url;

            let start = 0, end = 100;
            let description;

            // Highlight search in content
            if (GLOBAL.GHOST_SEARCH_IN_CONTENT && tag.item.description > 0) {
                const indexContent = tag.item.description.search(new RegExp(query, 'i'));

                if (indexContent > 50) {
                    start = indexContent - 50;
                    end = indexContent + 50;
                }

                description = tag.item.description.substring(start, end);

                description = indexContent > -1 
                    ? `...${tag.item.description.substring(start, indexContent)}<span class="font-bold">${tag.item.description.substring(indexContent, indexContent + query.length)}</span>${tag.item.description.substring(indexContent + query.length, end)}...`
                    : description;
            } else {
                description = tag.item.description ? tag.item.description.substring(start, end) : ''
            }
            //return `<img src="${feature_image}"> <a href="${url}" class="search-result w-full text-header text-sm py-2 px-4 outline-none focus:bg-header-hover hover:bg-header-hover">${name} - ${primary_tag} - ${description}</a> `;
            return `<a href="${url}" class="search-result w-full p-2 outline-none focus:bg-header-hover hover:bg-header-hover grid grid-cols-[auto_4rem] gap-2">
                        <div class="grid grid-cols-[2.5rem_1fr] gap-2.5">
                            <div class="relative aspect-[2/3] w-full">
                                <img src="${feature_image}" class="absolute top-0 left-0 h-full w-full object-cover object-center rounded"/>
                            </div>
                            <div class="flex flex-col gap-1">
                                <div class="text-primary font-semibold text-base line-clamp-1">${name}</div>
                                <p class="text-primary text-xs line-clamp-2">
                                    ${description}
                                </p>
                            </div>
                        </div>
                        <div class="flex items-center justify-center">
                            <div class="w-full relative flex items-center justify-center py-1 px-2 rounded-custom text-xs text-secondary border border-theme">
                                ${primary_tag}
                            </div>
                        </div>
                    </a>`;
        }).join(' ');

    } else {

        searchResults = results.map(function (post) {
            const indexTitle = post.item.title.search(new RegExp(query, 'i'));

            // Highlight search in title
            const title = indexTitle > -1 
                ? `${post.item.title.substring(0, indexTitle)}<span class="font-bold">${post.item.title.substring(indexTitle, indexTitle + query.length)}</span>${post.item.title.substring(indexTitle + query.length, post.item.title.length)}`
                : post.item.title

            const feature_image = post.item.feature_image;
            var primary_tag = post.item.tags.length > 0 ? post.item.tags[0].name : "";
            const url = post.item.url;

            let start = 0, end = 100;
            let excerpt;

            if(primary_tag.charAt(0) === '#'){
                primary_tag = primary_tag.substring(1);
                primary_tag = primary_tag.charAt(0).toUpperCase() + primary_tag.slice(1);
            }

            if(primary_tag === "Product"){
                primary_tag = "Theme";
            }

            var notArticle = ["Theme", "Hosting", "Bundle", "Tutorial", "Developer", "Feature"];

            if(notArticle.indexOf(primary_tag) === -1) { 
                primary_tag = "Article";
            }

            // Highlight search in content
            if (GLOBAL.GHOST_SEARCH_IN_CONTENT && post.item.plaintext > 0) {
                const indexContent = post.item.plaintext.search(new RegExp(query, 'i'));

                if (indexContent > 50) {
                    start = indexContent - 50;
                    end = indexContent + 50;
                }

                excerpt = post.item.plaintext.substring(start, end);

                excerpt = indexContent > -1 
                    ? `...${post.item.plaintext.substring(start, indexContent)}<span class="font-bold">${post.item.plaintext.substring(indexContent, indexContent + query.length)}</span>${post.item.plaintext.substring(indexContent + query.length, end)}...`
                    : excerpt;
            } else {
                excerpt = post.item.custom_excerpt ? post.item.custom_excerpt.substring(start, end) : ''
            }
            //return `<img src="${feature_image}"> <a href="${url}" class="search-result w-full text-header text-sm py-2 px-4 outline-none focus:bg-header-hover hover:bg-header-hover">${title} - ${primary_tag} - ${excerpt}</a> `;
            return `<a href="${url}" class="search-result w-full p-2 outline-none focus:bg-header-hover hover:bg-header-hover grid grid-cols-[auto_4rem] gap-2">
                        <div class="grid grid-cols-[2.5rem_1fr] gap-2.5">
                            <div class="relative aspect-[2/3] w-full">
                                <img src="${feature_image}" class="absolute top-0 left-0 h-full w-full object-cover object-center rounded"/>
                            </div>
                            <div class="flex flex-col gap-1">
                                <div class="text-primary font-semibold text-base line-clamp-1">${title}</div>
                                <p class="text-primary text-xs ">
                                    ${excerpt}
                                </p>
                            </div>
                        </div>
                        <div class="flex items-center justify-center">
                            <div class="w-full relative flex items-center justify-center py-1 px-2 rounded-custom text-xs text-secondary border border-theme">
                                ${primary_tag}
                            </div>
                        </div>
                    </a>`;
        }).join(' ');
    }
    resultEl.innerHTML = searchResults;
}

const handleTimeSpentOnPage = () => {
    var timeSpendContainers = document.getElementsByClassName('time-spent-container');
    if(timeSpendContainers.length > 0){
        let timeSpentScrolling = 0;
        let isHalted = false;
        let haltedStartTime, haltedEndTime;
        let totalHaltedTime = 0;
        const update_halt_state = () => {
        if (isHalted) {
            isHalted = false;
            haltedEndTime = new Date().getTime()
            totalHaltedTime += (haltedEndTime - haltedStartTime) / 1000
        } else {
            isHalted = true;
            haltedStartTime = new Date().getTime()
        }
        }
        window.addEventListener('scroll', () => {
        timeSpentScrolling += 1.8;
        update_halt_state()
        });

        // Event listener for page visibility changes
        document.addEventListener("visibilitychange", () => {
            if (document.hidden) {
                update_halt_state(); // Stop timer when the page is hidden
            } else {
                startTimer(); // Resume timer when the page becomes visible
            }
        });

        document.addEventListener("DOMContentLoaded", () => {
        const start = new Date().getTime();
        setInterval(() => {
            if (new Date().getTime() - start > 39000) {
            update_halt_state()
            }
        }, 39000)

        setInterval(() => {
            const end = new Date().getTime();
            update_halt_state()
            const totalTime = ((end - start) / 1000) - (timeSpentScrolling / 1000) - totalHaltedTime;
            
            [].slice.call( timeSpendContainers ).forEach(function ( timeSpendContainer ) {
                timeSpendContainer.innerHTML = Math.round(totalTime);
            });
        }, 5000);
        });
    }
}

function convertSeconds(seconds) {
    const secondsInMinute = 60;
    const secondsInHour = 60 * secondsInMinute;
    const secondsInDay = 24 * secondsInHour;
    const secondsInMonth = 30 * secondsInDay; // Approximate month length
    const secondsInYear = 365 * secondsInDay; // Non-leap year

    const years = Math.floor(seconds / secondsInYear);
    seconds %= secondsInYear;

    const months = Math.floor(seconds / secondsInMonth);
    seconds %= secondsInMonth;

    const days = Math.floor(seconds / secondsInDay);
    seconds %= secondsInDay;

    const hours = Math.floor(seconds / secondsInHour);
    seconds %= secondsInHour;

    const minutes = Math.floor(seconds / secondsInMinute);
    seconds %= secondsInMinute;

    const result = [];

    if (years > 0) result.push(`${years} year${years > 1 ? 's' : ''}`);
    if (months > 0) result.push(`${months} month${months > 1 ? 's' : ''}`);
    if (days > 0) result.push(`${days} day${days > 1 ? 's' : ''}`);
    if (hours > 0) result.push(`${hours} hour${hours > 1 ? 's' : ''}`);
    if (minutes > 0) result.push(`${minutes} minute${minutes > 1 ? 's' : ''}`);
    if (seconds > 0) result.push(`${seconds} second${seconds > 1 ? 's' : ''}`);

    return result.join(', ');
}

const handleTimeSpendOnWebsite = () => {
    // Global Variables
    let timer = null;
    let elapsedTime = 0; // Time in seconds
    const TIMER_KEY = 'elapsedTime';
    const STARTED_ON_KEY = 'startedOn';
    const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    };

    // Function to format date and time
    function formatDateTime(date) {
        return date.toLocaleString("en-US", options);
    }

    // Function to update the time spent in all elements with class 'time-spent-container'
    function updateDisplayTime() {
        const elements = document.querySelectorAll('.time-spent-container');
        elements.forEach(el => {
            el.innerHTML = convertSeconds(Number(elapsedTime));
        });
    }

    // Function to update the timer start time in elements with class 'timer-started-on-container'
    function updateStartedOn() {
        const startedOnElements = document.querySelectorAll('.timer-started-on-container');
        const startedOnValue = localStorage.getItem(STARTED_ON_KEY);
        const formattedDate = startedOnValue ? formatDateTime(new Date(startedOnValue)) : "Not Available";
        startedOnElements.forEach(el => {
            el.textContent = formattedDate;
        });
    }

    // Function to start or resume the timer
    function startTimer() {
        if (timer === null) { // Avoid duplicate intervals
            timer = setInterval(() => {
                elapsedTime++;
                localStorage.setItem(TIMER_KEY, elapsedTime); // Update elapsed time in local storage
                updateDisplayTime(); // Update time spent display
            }, 1000);
        }
    }

    // Function to stop the timer
    function stopTimer() {
        if (timer !== null) {
            clearInterval(timer);
            timer = null;
        }
    }

    // Function to handle page visibility changes
    function handleVisibilityChange() {
        if (document.hidden) {
            stopTimer(); // Pause the timer if the page is hidden
        } else {
            startTimer(); // Resume the timer if the page is visible
        }
    }

    // Initialize timer from local storage when the script loads
    window.onload = function () {
        const storedTime = localStorage.getItem(TIMER_KEY);
        const storedStartedOn = localStorage.getItem(STARTED_ON_KEY);

        // If no start time exists, set it now
        if (!storedStartedOn) {
            const currentDate = new Date();
            localStorage.setItem(STARTED_ON_KEY, currentDate.toISOString());
        }

        // Initialize elapsed time
        elapsedTime = storedTime ? parseInt(storedTime, 10) : 0;

        // Update displays
        updateDisplayTime();
        updateStartedOn();

        // Start the timer
        startTimer();
    };

    // Attach the visibility change event listener
    document.addEventListener("visibilitychange", handleVisibilityChange);
}

const handleAdSlotNotices = () => {
    if(document.getElementById("theme-slot-notices")){
        document.getElementById('theme-slot-0-notice').innerHTML = document.getElementById('theme-slot-0-notice-src').innerHTML;
        document.getElementById('theme-slot-1-notice').innerHTML = document.getElementById('theme-slot-1-notice-src').innerHTML;
        document.getElementById('theme-slot-2-notice').innerHTML = document.getElementById('theme-slot-2-notice-src').innerHTML;
        document.getElementById('theme-slot-3-notice').innerHTML = document.getElementById('theme-slot-3-notice-src').innerHTML;
        document.getElementById('theme-slot-4-notice').innerHTML = document.getElementById('theme-slot-4-notice-src').innerHTML;
    }
}

/**
 * Ghost Cards START
 */
const handleAudio = () => {
    const handleAudioPlayer = function (audioElementContainer) {
        const audioPlayerContainer = audioElementContainer.querySelector('.kg-audio-player-container');
        const playIconContainer = audioElementContainer.querySelector('.kg-audio-play-icon');
        const pauseIconContainer = audioElementContainer.querySelector('.kg-audio-pause-icon');
        const seekSlider = audioElementContainer.querySelector('.kg-audio-seek-slider');
        const playbackRateContainer = audioElementContainer.querySelector('.kg-audio-playback-rate');
        const muteIconContainer = audioElementContainer.querySelector('.kg-audio-mute-icon');
        const unmuteIconContainer = audioElementContainer.querySelector('.kg-audio-unmute-icon');
        const volumeSlider = audioElementContainer.querySelector('.kg-audio-volume-slider');
        const audio = audioElementContainer.querySelector('audio');
        const durationContainer = audioElementContainer.querySelector('.kg-audio-duration');
        const currentTimeContainer = audioElementContainer.querySelector('.kg-audio-current-time');
        let playbackRates = [{
            rate: 0.75,
            label: '0.7×'
        }, {
            rate: 1.0,
            label: '1×'
        }, {
            rate: 1.25,
            label: '1.2×'
        }, {
            rate: 1.75,
            label: '1.7×'
        }, {
            rate: 2.0,
            label: '2×'
        }];

        let raf = null;
        let currentPlaybackRateIdx = 1;

        const whilePlaying = () => {
            seekSlider.value = Math.floor(audio.currentTime);
            currentTimeContainer.textContent = calculateTime(seekSlider.value);
            audioPlayerContainer.style.setProperty('--seek-before-width', `${seekSlider.value / seekSlider.max * 100}%`);
            raf = requestAnimationFrame(whilePlaying);
        }

        const showRangeProgress = (rangeInput) => {
            if (rangeInput === seekSlider) {
                audioPlayerContainer.style.setProperty('--seek-before-width', rangeInput.value / rangeInput.max * 100 + '%');
            }
            else {
                audioPlayerContainer.style.setProperty('--volume-before-width', rangeInput.value / rangeInput.max * 100 + '%');
            }
        }

        const calculateTime = (secs) => {
            const minutes = Math.floor(secs / 60);
            const seconds = Math.floor(secs % 60);
            const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
            return `${minutes}:${returnedSeconds}`;
        }

        const displayDuration = () => {
            durationContainer.textContent = calculateTime(audio.duration);
        }

        const setSliderMax = () => {
            seekSlider.max = Math.floor(audio.duration);
        }

        const displayBufferedAmount = () => {
            if (audio.buffered.length > 0) {
                const bufferedAmount = Math.floor(audio.buffered.end(audio.buffered.length - 1));
                audioPlayerContainer.style.setProperty('--buffered-width', `${(bufferedAmount / seekSlider.max) * 100}%`);
            }
        }

        if (audio.readyState > 0) {
            displayDuration();
            setSliderMax();
            displayBufferedAmount();
        } else {
            audio.addEventListener('loadedmetadata', () => {
                displayDuration();
                setSliderMax();
                displayBufferedAmount();
            });
        }

        playIconContainer.addEventListener('click', () => {
            playIconContainer.classList.add("kg-audio-hide");
            pauseIconContainer.classList.remove("kg-audio-hide");
            audio.play();
            requestAnimationFrame(whilePlaying);
        });

        pauseIconContainer.addEventListener('click', () => {
            pauseIconContainer.classList.add("kg-audio-hide");
            playIconContainer.classList.remove("kg-audio-hide");
            audio.pause();
            cancelAnimationFrame(raf);
        });

        muteIconContainer.addEventListener('click', () => {
            muteIconContainer.classList.add("kg-audio-hide");
            unmuteIconContainer.classList.remove("kg-audio-hide");
            audio.muted = false;
        });

        unmuteIconContainer.addEventListener('click', () => {
            unmuteIconContainer.classList.add("kg-audio-hide");
            muteIconContainer.classList.remove("kg-audio-hide");
            audio.muted = true;
        });

        playbackRateContainer.addEventListener('click', () => {
            let nextPlaybackRate = playbackRates[(currentPlaybackRateIdx + 1) % 5];
            currentPlaybackRateIdx = currentPlaybackRateIdx + 1;
            audio.playbackRate = nextPlaybackRate.rate;
            playbackRateContainer.textContent = nextPlaybackRate.label;
        });

        audio.addEventListener('progress', displayBufferedAmount);

        seekSlider.addEventListener('input', (e) => {
            showRangeProgress(e.target);
            currentTimeContainer.textContent = calculateTime(seekSlider.value);
            if (!audio.paused) {
                cancelAnimationFrame(raf);
            }
        });

        seekSlider.addEventListener('change', () => {
            audio.currentTime = seekSlider.value;
            if (!audio.paused) {
                requestAnimationFrame(whilePlaying);
            }
        });

        volumeSlider.addEventListener('input', (e) => {
            const value = e.target.value;
            showRangeProgress(e.target);
            audio.volume = value / 100;
        });
    }

    const audioCardElements = document.querySelectorAll('.kg-audio-card');

    for (let i = 0; i < audioCardElements.length; i++) {
        handleAudioPlayer(audioCardElements[i]);
    }
}

const handleGallery = () => {
    const images = document.querySelectorAll('.kg-gallery-image img');
    images.forEach(function (image) {
        const container = image.closest('.kg-gallery-image');
        const width = image.attributes.width.value;
        const height = image.attributes.height.value;
        const ratio = width / height;
        container.style.flex = ratio + ' 1 0%';
    })
}

const handleToggle = () => {
    const toggleHeadingElements = document.getElementsByClassName("kg-toggle-heading");

    const toggleFn = function(event) {
        const targetElement = event.target;
        const parentElement = targetElement.closest('.kg-toggle-card');
        var toggleState = parentElement.getAttribute("data-kg-toggle-state");
        if (toggleState === 'close') {
            parentElement.setAttribute('data-kg-toggle-state', 'open');
        } else {
            parentElement.setAttribute('data-kg-toggle-state', 'close');
        }
    };

    for (let i = 0; i < toggleHeadingElements.length; i++) {
        toggleHeadingElements[i].addEventListener('click', toggleFn, false);
    }
}

const handleVideo = () => {
    const handleVideoPlayer = function (videoElementContainer) {
        const videoPlayer = videoElementContainer.querySelector('.kg-video-player');
        const videoPlayerContainer = videoElementContainer.querySelector('.kg-video-player-container');
        const playIconContainer = videoElementContainer.querySelector('.kg-video-play-icon');
        const pauseIconContainer = videoElementContainer.querySelector('.kg-video-pause-icon');
        const seekSlider = videoElementContainer.querySelector('.kg-video-seek-slider');
        const playbackRateContainer = videoElementContainer.querySelector('.kg-video-playback-rate');
        const muteIconContainer = videoElementContainer.querySelector('.kg-video-mute-icon');
        const unmuteIconContainer = videoElementContainer.querySelector('.kg-video-unmute-icon');
        const volumeSlider = videoElementContainer.querySelector('.kg-video-volume-slider');
        const videoEl = videoElementContainer.querySelector('video');
        const durationContainer = videoElementContainer.querySelector('.kg-video-duration');
        const currentTimeContainer = videoElementContainer.querySelector('.kg-video-current-time');
        const largePlayIcon = videoElementContainer.querySelector('.kg-video-large-play-icon');
        const videoOverlay = videoElementContainer.querySelector('.kg-video-overlay');
        let playbackRates = [{
            rate: 0.75,
            label: '0.7×'
        }, {
            rate: 1.0,
            label: '1×'
        }, {
            rate: 1.25,
            label: '1.2×'
        }, {
            rate: 1.75,
            label: '1.7×'
        }, {
            rate: 2.0,
            label: '2×'
        }];

        let raf = null;
        let currentPlaybackRateIdx = 1;
        if (!!videoEl.loop) {
            largePlayIcon.classList.add("kg-video-hide-animated");
            videoOverlay.classList.add("kg-video-hide-animated");
        }
        const whilePlaying = () => {
            seekSlider.value = Math.floor(videoEl.currentTime);
            currentTimeContainer.textContent = calculateTime(seekSlider.value);
            videoPlayer.style.setProperty('--seek-before-width', `${seekSlider.value / seekSlider.max * 100}%`);
            raf = requestAnimationFrame(whilePlaying);
        }

        const showRangeProgress = (rangeInput) => {
            if (rangeInput === seekSlider) {
                videoPlayer.style.setProperty('--seek-before-width', rangeInput.value / rangeInput.max * 100 + '%');
            }
            else {
                videoPlayer.style.setProperty('--volume-before-width', rangeInput.value / rangeInput.max * 100 + '%');
            }
        }

        const calculateTime = (secs) => {
            const minutes = Math.floor(secs / 60);
            const seconds = Math.floor(secs % 60);
            const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
            return `${minutes}:${returnedSeconds}`;
        }

        const displayDuration = () => {
            durationContainer.textContent = calculateTime(videoEl.duration);
        }

        const setSliderMax = () => {
            seekSlider.max = Math.floor(videoEl.duration);
        }

        const displayBufferedAmount = () => {
            if (videoEl.buffered.length > 0) {
                const bufferedAmount = Math.floor(videoEl.buffered.end(videoEl.buffered.length - 1));
                videoPlayer.style.setProperty('--buffered-width', `${(bufferedAmount / seekSlider.max) * 100}%`);
            }
        }

        if (videoEl.readyState > 0) {
            displayDuration();
            setSliderMax();
            displayBufferedAmount();
            if (videoEl.autoplay) {
                raf = requestAnimationFrame(whilePlaying);
                playIconContainer.classList.add("kg-video-hide");
                pauseIconContainer.classList.remove("kg-video-hide");
            }
            if (videoEl.muted) {
                unmuteIconContainer.classList.add("kg-video-hide");
                muteIconContainer.classList.remove("kg-video-hide");
            }
        } else {
            videoEl.addEventListener('loadedmetadata', () => {
                displayDuration();
                setSliderMax();
                displayBufferedAmount();
                if (videoEl.autoplay) {
                    raf = requestAnimationFrame(whilePlaying);
                    playIconContainer.classList.add("kg-video-hide");
                    pauseIconContainer.classList.remove("kg-video-hide");
                }
                if (videoEl.muted) {
                    unmuteIconContainer.classList.add("kg-video-hide");
                    muteIconContainer.classList.remove("kg-video-hide");
                }
            });
        }

        videoElementContainer.onmouseover = () => {
            if (!videoEl.loop) {
                videoPlayerContainer.classList.remove("kg-video-hide-animated");
            }
        }

        videoElementContainer.onmouseleave = () => {
            const isPlaying = !!(videoEl.currentTime > 0 && !videoEl.paused && !videoEl.ended && videoEl.readyState > 2);
            if (isPlaying) {
                videoPlayerContainer.classList.add("kg-video-hide-animated");
            }
        }

        videoElementContainer.addEventListener('click', () => {
            if (!videoEl.loop) {
                const isPlaying = !!(videoEl.currentTime > 0 && !videoEl.paused && !videoEl.ended && videoEl.readyState > 2);
                if (isPlaying) {
                    handleOnPause();
                } else {
                    handleOnPlay();
                }
            }
        });

        videoEl.onplay = () => {
            largePlayIcon.classList.add("kg-video-hide-animated");
            videoOverlay.classList.add("kg-video-hide-animated");
            playIconContainer.classList.add("kg-video-hide");
            pauseIconContainer.classList.remove("kg-video-hide");
        };

        const handleOnPlay = () => {
            largePlayIcon.classList.add("kg-video-hide-animated");
            videoOverlay.classList.add("kg-video-hide-animated");
            playIconContainer.classList.add("kg-video-hide");
            pauseIconContainer.classList.remove("kg-video-hide");
            videoEl.play();
            raf = requestAnimationFrame(whilePlaying);
        }

        const handleOnPause = () => {
            pauseIconContainer.classList.add("kg-video-hide");
            playIconContainer.classList.remove("kg-video-hide");
            videoEl.pause();
            cancelAnimationFrame(raf);
        }

        largePlayIcon.addEventListener('click', (event) => {
            event.stopPropagation();
            handleOnPlay();
        });

        playIconContainer.addEventListener('click', (event) => {
            event.stopPropagation();
            handleOnPlay();
        });

        pauseIconContainer.addEventListener('click', (event) => {
            event.stopPropagation();
            handleOnPause();
        });

        muteIconContainer.addEventListener('click', (event) => {
            event.stopPropagation();
            muteIconContainer.classList.add("kg-video-hide");
            unmuteIconContainer.classList.remove("kg-video-hide");
            videoEl.muted = false;
        });

        unmuteIconContainer.addEventListener('click', (event) => {
            event.stopPropagation();
            unmuteIconContainer.classList.add("kg-video-hide");
            muteIconContainer.classList.remove("kg-video-hide");
            videoEl.muted = true;
        });

        playbackRateContainer.addEventListener('click', (event) => {
            event.stopPropagation();
            let nextPlaybackRate = playbackRates[(currentPlaybackRateIdx + 1) % 5];
            currentPlaybackRateIdx = currentPlaybackRateIdx + 1;
            videoEl.playbackRate = nextPlaybackRate.rate;
            playbackRateContainer.textContent = nextPlaybackRate.label;
        });

        videoEl.addEventListener('progress', displayBufferedAmount);

        seekSlider.addEventListener('input', (e) => {
            e.stopPropagation();
            showRangeProgress(e.target);
            currentTimeContainer.textContent = calculateTime(seekSlider.value);
            if (!videoEl.paused) {
                cancelAnimationFrame(raf);
            }
        });

        seekSlider.addEventListener('change', (event) => {
            event.stopPropagation();
            videoEl.currentTime = seekSlider.value;
            if (!videoEl.paused) {
                requestAnimationFrame(whilePlaying);
            }
        });

        volumeSlider.addEventListener('click', (event) => {
            event.stopPropagation();
        });

        seekSlider.addEventListener('click', (event) => {
            event.stopPropagation();
        });

        volumeSlider.addEventListener('input', (e) => {
            e.stopPropagation();
            const value = e.target.value;
            showRangeProgress(e.target);
            videoEl.volume = value / 100;
        });
    }

    const videoCardElements = document.querySelectorAll('.kg-video-card');

    for (let i = 0; i < videoCardElements.length; i++) {
        handleVideoPlayer(videoCardElements[i]);
    }
}
/**
 * Ghost Cards END
 */

/**
 * DOM Loaded event
 */
export default function handler() {
    handleMobileNavigation();
    handleDropdown();
    handleSearchFilterOption();
 //   handleSelectedFilters();
    handleProductCards();
    handleSearch();
    handleScrollToTop();
    handleExternalLinks();
    handleTimeSpendOnWebsite();
    handleHomeAnimation();
    handleBundleCards();
    addBundleCardEvents();
    handleHostingCards();
    handleExpertCards();
    handleFilter();
    handleCouponCodes();
    handleProductPage();
    handleAudio();
    handleGallery();
    handleToggle();
    handleVideo();
    handleAdSlotNotices();
    reframe('.blog-content iframe:not([src*="soundcloud"]):not([src*="spotify"]):not([src*="googletagmanager"]):not(.no-resize)');
}